import { Swiper, Navigation, Keyboard } from 'swiper';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

import '/components/image-carousel/image-carousel-lazy.scss';

Swiper.use([Navigation, Keyboard]);

(() => {
    const carousels = Array.from(
        document.querySelectorAll('.swiper-container')
    );

    carousels.forEach((carousel) => {
        console.log(carousel);
        new Swiper(carousel, {
            // eslint-disable-line no-new
            centeredSlides: true,
            centeredSlidesBounds: true,
            grabCursor: true,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer: true,
            observeSlideChildren: true,
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            spaceBetween: 30,
            watchOverflow: true,
        });
    });
})();
